import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    makeStyles,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SendIcon from '@material-ui/icons/Send';
import Rating from '@material-ui/lab/Rating';
import clsx from 'clsx';
import { useState } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(4),
        borderRadius: 20,
    },
    submitBtn: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(1.5),
        fontWeight: 'bold',
    },
    uploadBox: {
        border: '2px dashed #ccc',
        padding: theme.spacing(3),
        textAlign: 'center',
        cursor: 'pointer',
        marginTop: theme.spacing(2),
        borderRadius: 8,
        '&:hover': {
            backgroundColor: '#f9f9f9'
        }
    }
}));

function TechnicianFeedback({ className, ...rest }) {
    const classes = useStyles();

    // Form State'leri
    const [category, setCategory] = useState('oneri');
    const [rating, setRating] = useState(5);
    const [description, setDescription] = useState('');
    const [selectedFileBase64, setSelectedFileBase64] = useState(null);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);

    // Dosyayı Base64 formatına çeviren yardımcı fonksiyon
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                // reader.result, API'nin beklediği base64 string'ini içerir
                setSelectedFileBase64(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const SetTechnicianFeedback = async (e) => {
        e.preventDefault();
        setLoading(true);
        let SessionUser = getUser();
        // API örneğinizdeki [FromBody] ArtemisUrunKabulRequest yapısına uygun obje
        const requestParam = {
            category: category,
            rating: parseInt(rating, 10) || 0, // Int32 olarak gönder
            description: description,
            imageBase64: selectedFileBase64, // Backend'deki property ismine göre güncelleyin
            fileName: fileName,
            ServiceShopId: SessionUser.ServiceShopId || 0,
            UserId: SessionUser.UserId || '0',
        };

        try {
            // API endpoint ve parametre yapısı
            const response = await axios.post('/SetTechnicianFeedback', requestParam, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.data) {
                alert('Geri bildiriminiz başarıyla iletildi!');
                // Formu sıfırla
                setDescription('');
                setRating(5);
                setSelectedFileBase64(null);
                setFileName('');
            }
        } catch (error) {
            logger.error("API Hatası:", error);
            alert('Gönderim sırasında bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={clsx(classes.root, className)} {...rest}>
            <Paper elevation={3} className={classes.paper}>
                <Typography variant="h5" gutterBottom style={{ fontWeight: 600 }}>
                    Saha Geri Bildirim Formu
                </Typography>
                <Typography variant="body2" color="textSecondary" paragraph>
                    Lütfen karşılaştığınız sorunu veya önerinizi iletin.
                </Typography>

                <Divider style={{ margin: '16px 0' }} />

                <form onSubmit={SetTechnicianFeedback}>
                    <FormControl component="fieldset" fullWidth margin="normal">
                        <FormLabel component="legend">Konu Kategorisi</FormLabel>
                        <RadioGroup
                            row
                            name="category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                        >
                            <FormControlLabel value="oneri" control={<Radio color="primary" />} label="Öneri" />
                            <FormControlLabel value="diger" control={<Radio color="primary" />} label="Diğer" />
                        </RadioGroup>
                    </FormControl>

                    <Box my={2}>
                        <Typography component="legend">Genel Durum Puanı</Typography>
                        <Rating
                            name="rating"
                            value={rating}
                            size="large"
                            onChange={(event, newValue) => setRating(newValue)}
                        />
                    </Box>

                    <TextField
                        fullWidth
                        label="Detaylı Açıklama"
                        multiline
                        minRows={4}
                        variant="outlined"
                        required
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />

                    <Box className={classes.uploadBox}>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label htmlFor="raised-button-file" style={{ cursor: 'pointer', width: '100%' }}>
                            <CloudUploadIcon fontSize="large" color={selectedFileBase64 ? "primary" : "action"} />
                            <Typography variant="body2">
                                {fileName ? `Seçildi: ${fileName}` : "Fotoğraf Ekle (Opsiyonel)"}
                            </Typography>
                        </label>
                    </Box>

                    <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        size="large"
                        className={classes.submitBtn}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? "Gönderİlİyor..." : "Gerİ Bİldİrİm Gönder"}
                    </Button>
                </form>
            </Paper>
        </div>
    );
}

export default TechnicianFeedback;